import { AIChatbot } from "../../../features/ai_chatbots/aiChatbotsService";

const OVERLAY_ID = "ai-chatbot-preview-overlay";
const EXIT_ID = "ai-chatbot-exit-preview";

const ensureWidgetScript = (): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const w = window as any;
    if (w.AIChatbot && typeof w.AIChatbot.init === "function") {
      resolve();
      return;
    }
    const existing = document.querySelector('script[data-ai-widget="true"]') as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject());
      return;
    }
    const s = document.createElement("script");
    s.src = `${window.location.origin}/assets/js/chatbot-widget.js`;
    s.async = true;
    (s as any).dataset.aiWidget = "true";
    s.onload = () => resolve();
    s.onerror = () => reject();
    document.body.appendChild(s);
  });

export const startWidgetPreview = async (chatbot: AIChatbot) => {
  if (!chatbot) return;
  const w = window as any;
  // Clean any previous preview DOM
  stopWidgetPreview();

  // Create overlay
  const overlay = document.createElement("div");
  overlay.id = OVERLAY_ID;
  overlay.style.position = "fixed";
  (overlay.style as any).inset = "0";
  overlay.style.background = "rgba(15,23,42,0.35)";
  overlay.style.zIndex = "9998";
  (overlay.style as any).backdropFilter = "blur(2px)";
  overlay.style.pointerEvents = "auto";
  overlay.onclick = (e) => {
    if ((e.target as HTMLElement).id === OVERLAY_ID) {
      stopWidgetPreview();
    }
  };
  document.body.appendChild(overlay);

  // Exit button
  const exitBtn = document.createElement("button");
  exitBtn.id = EXIT_ID;
  exitBtn.textContent = "Exit Preview";
  exitBtn.style.position = "fixed";
  exitBtn.style.top = "16px";
  exitBtn.style.right = "16px";
  exitBtn.style.zIndex = "10000";
  exitBtn.style.padding = "10px 14px";
  exitBtn.style.borderRadius = "10px";
  exitBtn.style.border = "none";
  exitBtn.style.cursor = "pointer";
  exitBtn.style.fontWeight = "600";
  exitBtn.style.color = "#fff";
  exitBtn.style.background = "linear-gradient(135deg,#667eea,#764ba2)";
  exitBtn.onclick = () => stopWidgetPreview();
  document.body.appendChild(exitBtn);

  await ensureWidgetScript();
  const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1") + "/public/chatbot";
  const widgetKey = (chatbot as any).widget_key;

  let override: any = null;
  try {
    const ws = (chatbot as any).widget_settings;
    if (ws) override = typeof ws === "string" ? JSON.parse(ws) : ws;
  } catch {}
  
  if (w.AIChatbot && typeof w.AIChatbot.init === "function") {
    w.AIChatbot.init({ 
      apiUrl, 
      widgetKey, 
      widgetSettingsOverride: override,
      isPreviewMode: true 
    });
  }
};

export const stopWidgetPreview = () => {
  const overlay = document.getElementById(OVERLAY_ID);
  if (overlay) overlay.remove();
  const exitBtn = document.getElementById(EXIT_ID);
  if (exitBtn) exitBtn.remove();
  const container = document.getElementById("ai-chatbot-widget-container");
  if (container) container.remove();
};

export default startWidgetPreview;


